import { logger } from '@lib/logger'
import { ImageOptimizerParams } from 'types/utils/images'

const imgixHostnames = ['imgix.net', 'cdn-images.tablelist.com']

export function imageOptimize(
  imgUrl?: string,
  {
    w,
    h,
    q = '50',
    dpr = '1',
    fm = 'webp',
    fit = 'fill',
    fill = 'blur',
    bg,
  }: ImageOptimizerParams = {}
): string | undefined {
  if (!imgUrl) return
  try {
    const urlObject = new URL(imgUrl)
    if (
      !imgixHostnames.some((hostname) => urlObject.hostname.includes(hostname))
    ) {
      return imgUrl
    }

    if (w) urlObject.searchParams.set('w', w)
    if (h) urlObject.searchParams.set('h', h)
    if (bg) urlObject.searchParams.set('bg', bg)
    urlObject.searchParams.set('fit', fit)
    urlObject.searchParams.set('fill', fill)
    urlObject.searchParams.set('fm', fm)
    urlObject.searchParams.set('q', q)
    urlObject.searchParams.set('dpr', dpr)

    return urlObject.href
  } catch (e) {
    logger.error(
      'imageOptimize: Error, could not construct URL Object from the image url input'
    )
    return imgUrl
  }
}
